import { gql } from '@apollo/client';
export const INTEGRATION_CONFIG_FIELDS = gql `
  fragment IntegrationConfigFields on IntegrationConfig {
    id
    clientId
    name
    createdAt
    updatedAt
    type
    direction
    isActive
    settings {
      filenamePattern
      folder
      archiveFolder
      archiveFiles
    }
    lastRunAt
    lastRunStatus
    serverId
  }
`;
export const INTEGRATION_CONFIGS = gql `
  ${INTEGRATION_CONFIG_FIELDS}
  query INTEGRATION_CONFIGS($spec: IntegrationConfigSpec!) {
    integrationConfigs(spec: $spec) {
      ...IntegrationConfigFields
    }
  }
`;
// not really sure if we need this
// export const CURRENT_INTEGRATION_CONFIGS = gql`
//   query CURRENT_INTEGRATION_CONFIGS {
//     currentIntegrationConfigs {
//       id
//       name
//       provider
//     }
//   }
// `;
export const SAVE_INTEGRATION_CONFIG = gql `
  ${INTEGRATION_CONFIG_FIELDS}
  mutation SAVE_INTEGRATION_CONFIG($input: IntegrationConfigInput!) {
    saveIntegrationConfig(input: $input) {
      ...IntegrationConfigFields
    }
  }
`;
export const DELETE_INTEGRATION_CONFIG = gql `
  mutation DELETE_INTEGRATION_CONFIG($id: Int!) {
    deleteIntegrationConfig(id: $id) {
      id
      name
    }
  }
`;
